export default __webpack_public_path__ + "static/media/1.2703d3b2.png";